import { Component } from '@angular/core';

/** Approved custom lettering, stored as outlines rather than a substitute font. */
@Component({
  selector: 'app-brand-wordmark',
  standalone: true,
  host: { 'aria-hidden': 'true' },
  templateUrl: './brand-wordmark.svg',
  styles: [`
    :host { display: block; flex-shrink: 0; color: inherit; }
    svg { display: block; width: 100%; height: 100%; }
  `],
})
export class AppBrandWordmarkComponent {}
